import gql from 'graphql-tag';

const GET_SUMMARY_TYPES = gql`
  query {
    getSummaryTypes
  }
`;

const GET_SUMMARY_CONTENT = gql`
  query getSummaryContent($input: SummaryInput!) {
    getSummaryContent(input: $input)
  }
`;

const TEST_AI_PROMPT = gql`
  query testAIPrompt($prompt: String!, $text: String!) {
    testAIPrompt(prompt: $prompt, text: $text)
  }
`;

const APPLY_AI_PROMPT = gql`
  query applyAIPrompt($featureId: ID!, $text: String!) {
    applyAIPrompt(featureId: $featureId, text: $text)
  }
`;

const GET_CATEGORY_SUMMARY = gql`
  query getCategorySummary($input: CategorySummaryInput!) {
    getCategorySummary(input: $input) {
      summary
      groupSummaries {
        name
        summary
      }
      solution
    }
  }
`;

const GET_TICKET_WORKLOG_SUMMARY = gql`
  query getWorklogSummary($ticketId: ID!) {
    getWorklogSummary(ticketId: $ticketId) {
      summaryPoints
      totalTime
      recordedTime
    }
  }
`;

const GET_AI_WORKLOG_NOTE = gql`
  query convertReplyToAIWorklog($text: String!) {
    convertReplyToAIWorklog(text: $text)
  }
`;

export {
  GET_SUMMARY_TYPES,
  GET_SUMMARY_CONTENT,
  TEST_AI_PROMPT,
  APPLY_AI_PROMPT,
  GET_CATEGORY_SUMMARY,
  GET_TICKET_WORKLOG_SUMMARY,
  GET_AI_WORKLOG_NOTE
};
